export function ruDeclension(num: number, titles: string[]) {
  return num % 1
    ? titles[1]
    : titles[(num % 100 > 4 && num % 100 < 20)
      ?  2
      : ([2, 0, 1, 1, 1, 2])[Math.min(num % 10, 5)]].replace('%s', num.toString());
}